import { render, staticRenderFns } from "./AttachmentsEditor.vue?vue&type=template&id=7dba1cec&"
import script from "./AttachmentsEditor.vue?vue&type=script&lang=js&"
export * from "./AttachmentsEditor.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports